module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-02.a4d7a733.jpg";